/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { OcppMessage, OcppMessageInitialState } from '../../interface/ocpp-messageV2.interface';

const initialState: OcppMessageInitialState = {
  messages: [], // will store latest data per connector
  currentMessage: [], // last received raw message
};

export const ocppMessageSlice = createSlice({
  name: 'ocpp-message',
  initialState,
  reducers: {
    /**
     * Store latest message for each connector (no duplicates)
     */
    pushReceivedMessage: (state, action: PayloadAction<OcppMessage>) => {
      const newMessage = action.payload;
      const connector = newMessage.connector ?? newMessage.connectorId;

      if (connector === undefined || connector === null) return;

      // Normalize for consistent lookup
      const normalizedMessage = { ...newMessage, connector };

      // Check if connector already exists
      const index = state.messages.findIndex(
        (message) => (message.connector ?? message.connectorId) === connector
      );

      if (index !== -1) {
        // Update existing connector data
        state.messages[index] = normalizedMessage;
      } else {
        // Add new connector data
        state.messages.push(normalizedMessage);
      }
    },

    /**
     * Store last received message (raw)
     */
    lastReceiveMessage: (state, action: PayloadAction<OcppMessage>) => {
      state.currentMessage = [action.payload]; // wrap as array
    },
  },
});

export const { pushReceivedMessage, lastReceiveMessage } = ocppMessageSlice.actions;

export default ocppMessageSlice.reducer;
